export default __webpack_public_path__ + "static/media/step9_poi_image1.2caee905.jpg";